"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnchorButton = AnchorButton;
exports.Button = Button;
var _core = require("@blueprintjs/core");
var _classnames = _interopRequireDefault(require("classnames"));
var React = _interopRequireWildcard(require("react"));
var _buttonStyle = require("../../common/buttonStyle");
var _thumbtackClasses = require("../../common/thumbtackClasses");
var _Icon = require("../icon/Icon");
var _excluded = ["buttonStyle", "children", "className", "icon", "intent", "minimal", "outlined", "rightIcon"],
  _excluded2 = ["buttonStyle", "children", "className", "icon", "rightIcon"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * NOTE: (Luce) WE do not allow `outlined` or `intent` props. Use `buttonStyle` instead
 */

/**
 * NOTE: (Luce) I considered removing the deprecated props altogether, however given that we do not currently enforce `noImplicitAny`
 * within Pinpoint it seems rather reckless to pull them entirely, as this could lead to a load of bugs.
 * For now this means marking them as deprecated so any usage should get flagged within the developers IDE of choice
 */
function Button(_ref) {
  var buttonStyle = _ref.buttonStyle,
    children = _ref.children,
    className = _ref.className,
    icon = _ref.icon,
    intent = _ref.intent,
    minimal = _ref.minimal,
    outlined = _ref.outlined,
    rightIcon = _ref.rightIcon,
    blueprintProps = _objectWithoutProperties(_ref, _excluded);
  function interpretedIcon(maybeIcon) {
    return typeof maybeIcon === 'string' ? /*#__PURE__*/React.createElement(_Icon.Icon16, {
      icon: maybeIcon
    }) : maybeIcon;
  }

  /**
   * This was added to fix a storybook a11y issue where there's no text displayed when the button is loading
   */
  var a11yProps = {};
  if (blueprintProps.loading) {
    a11yProps = {
      'aria-label': 'Loading'
    };
  }
  var classes = (0, _classnames.default)((0, _thumbtackClasses.buttonStyleClass)(buttonStyle || _buttonStyle.ButtonStyle.PRIMARY), className);
  return /*#__PURE__*/React.createElement(_core.Button, _extends({}, a11yProps, blueprintProps, {
    className: classes,
    icon: interpretedIcon(icon),
    rightIcon: interpretedIcon(rightIcon)
  }), children);
}
function AnchorButton(_ref2) {
  var buttonStyle = _ref2.buttonStyle,
    children = _ref2.children,
    className = _ref2.className,
    icon = _ref2.icon,
    rightIcon = _ref2.rightIcon,
    blueprintProps = _objectWithoutProperties(_ref2, _excluded2);
  var classes = (0, _classnames.default)((0, _thumbtackClasses.buttonStyleClass)(buttonStyle || _buttonStyle.ButtonStyle.PRIMARY), className);
  function interpretedIcon(maybeIcon) {
    return typeof maybeIcon === 'string' ? /*#__PURE__*/React.createElement(_Icon.Icon16, {
      icon: maybeIcon
    }) : maybeIcon;
  }
  return /*#__PURE__*/React.createElement(_core.AnchorButton, _extends({}, blueprintProps, {
    className: classes,
    icon: interpretedIcon(icon),
    rightIcon: interpretedIcon(rightIcon)
  }), children);
}